export var ActionLogs;
(function (ActionLogs) {
    ActionLogs[ActionLogs["ADMIN_BOOKING_CREATE"] = 2023] = "ADMIN_BOOKING_CREATE";
    ActionLogs[ActionLogs["MANAGER_BOOKING_CREATE"] = 3001] = "MANAGER_BOOKING_CREATE";
    ActionLogs[ActionLogs["PUBLIC_BOOKING_CREATE"] = 1001] = "PUBLIC_BOOKING_CREATE";
    ActionLogs[ActionLogs["CHECKOUT_SESSION_STATUS"] = 1006] = "CHECKOUT_SESSION_STATUS";
    ActionLogs[ActionLogs["ADMIN_INVOICE_GENERATE"] = 2041] = "ADMIN_INVOICE_GENERATE";
    ActionLogs[ActionLogs["ADMIN_ITEMS_DELETE"] = 2046] = "ADMIN_ITEMS_DELETE";
})(ActionLogs || (ActionLogs = {}));
export const communicationTemplateLogs = {
    'CREATE': {
        'logCode': 2039,
        'logMessage': 'Communication template created'
    },
    'READ': {
        'logCode': 2040,
        'logMessage': 'Communication template read'
    },
    'UPDATE': {
        'logCode': 2041,
        'logMessage': 'Communication template updated'
    },
    'DELETE': {
        'logCode': 2042,
        'logMessage': 'Communication template deleted'
    }
};
export var UserAnnouncementLogs;
(function (UserAnnouncementLogs) {
    UserAnnouncementLogs[UserAnnouncementLogs["USER_ANNOUNCEMENT_GET"] = 2047] = "USER_ANNOUNCEMENT_GET";
    UserAnnouncementLogs[UserAnnouncementLogs["USER_ANNOUNCEMENT_UPDATE"] = 2048] = "USER_ANNOUNCEMENT_UPDATE";
})(UserAnnouncementLogs || (UserAnnouncementLogs = {}));
export const ActionOutcomes = {
    SUCCESS: "success",
    FAILURE: "failure",
};
//# sourceMappingURL=logs.js.map